import React from 'react';
import { Helmet } from "react-helmet-async";

function Head() {

    const schemaOrgJSONLD = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "Organization",
                "@id": "https://www.bodhi.app/#organization",
                "name": "Bodhi",
                "legalName": "Vedic Bodhi Technologies Private Limited",
                "url": "https://www.bodhi.app/",
                "logo": "https://www.bodhi.app/assets/img/bodhi/logo.png",
                "description": "Bodhi is an astrologer consultation service where users chat or call verified astrologers for Tarot, Kundli, Numerology, Vastu, Palmistry and KP astrology guidance, on the website and via Android & iOS apps.",
                "email": "info@bodhiness.com",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "R-11/34, Rajnagar",
                    "addressLocality": "Ghaziabad",
                    "addressRegion": "Uttar Pradesh",
                    "postalCode": "201001",
                    "addressCountry": "IN"
                },
                "contactPoint": {
                    "@type": "ContactPoint",
                    "telephone": "+91-81302-17308",
                    "contactType": "customer service",
                    "availableLanguage": ["en", "hi"]
                },
                "sameAs": [
                    "https://www.instagram.com/bodhiness/",
                    "https://www.linkedin.com/company/bodhiapp/",
                    "https://www.youtube.com/channel/UCgfXfMCqazHrtMTFL2dLviA",
                    "https://www.quora.com/profile/Bodhi-93/",
                    "https://www.facebook.com/BodhiApp/",
                    "https://play.google.com/store/apps/details?id=com.rs.bodhi",
                    "https://apps.apple.com/in/app/bodhi-talk-to-astrologer/id1603849115"
                ]
            },
            {
                "@type": "WebSite",
                "@id": "https://www.bodhi.app/#website",
                "url": "https://www.bodhi.app/",
                "name": "Bodhi",
                "publisher": { "@id": "https://www.bodhi.app/#organization" },
                "inLanguage": ["en-IN", "hi-IN"],
                "potentialAction": {
                    "@type": "SearchAction",
                    "target": {
                        "@type": "EntryPoint",
                        "urlTemplate": "https://www.bodhi.app/blog/?s={search_term_string}"
                    },
                    "query-input": "required name=search_term_string"
                }
            },
            {
                "@type": "Service",
                "@id": "https://www.bodhi.app/#consultation-service",
                "serviceType": "Online astrology consultation",
                "name": "Talk to an Astrologer - Chat or Call",
                "description": "Chat or call 700+ verified astrologers directly on Bodhi for Tarot, Kundli, Numerology, Vastu, Palmistry, KP and love, marriage and career guidance. First consultation from Rs 9.",
                "provider": { "@id": "https://www.bodhi.app/#organization" },
                "areaServed": { "@type": "Country", "name": "India" },
                "availableChannel": {
                    "@type": "ServiceChannel",
                    "serviceUrl": "https://www.bodhi.app/",
                    "availableLanguage": ["en", "hi"]
                },
                "offers": {
                    "@type": "Offer",
                    "price": "9",
                    "priceCurrency": "INR",
                    "description": "First chat or call consultation"
                }
            },
            {
                "@type": "MobileApplication",
                "@id": "https://www.bodhi.app/#android-app",
                "name": "Bodhi: Talk to Astrologer",
                "operatingSystem": "ANDROID",
                "applicationCategory": "LifestyleApplication",
                "installUrl": "https://play.google.com/store/apps/details?id=com.rs.bodhi",
                "downloadUrl": "https://play.google.com/store/apps/details?id=com.rs.bodhi",
                "publisher": { "@id": "https://www.bodhi.app/#organization" },
                "offers": { "@type": "Offer", "price": "0", "priceCurrency": "INR" },
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "4.6",
                    "ratingCount": "12679"
                }
            },
            {
                "@type": "MobileApplication",
                "@id": "https://www.bodhi.app/#ios-app",
                "name": "Bodhi: Talk to Astrologer",
                "operatingSystem": "IOS",
                "applicationCategory": "LifestyleApplication",
                "installUrl": "https://apps.apple.com/in/app/bodhi-talk-to-astrologer/id1603849115",
                "downloadUrl": "https://apps.apple.com/in/app/bodhi-talk-to-astrologer/id1603849115",
                "publisher": { "@id": "https://www.bodhi.app/#organization" },
                "offers": { "@type": "Offer", "price": "0", "priceCurrency": "INR" }
            }
        ]
    };

    return(
    <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        <link rel="icon" type="image/png" href="bodhi-logo.jpeg" />
        <link href="https://www.bodhi.app/assets/img/bodhi/favicon.png" rel="icon" />
        <link rel="canonical" href="https://www.bodhi.app/" />

        <title>Talk to Astrologers Online | Bodhi App</title>
        <meta
            name="description"
            content="Chat or call 700+ verified astrologers on Bodhi for Tarot, Kundli, Numerology, Vastu & love and career guidance. First consultation from Rs 9." />
        <meta
            name="keywords"
            content="talk to astrologer, online astrology, free horoscope, kundli, tarot card reading, numerology, vastu, palmistry, daily horoscope, zodiac signs, rashifal, bodhi app" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.bodhi.app/" />
        <meta property="og:title" content="Talk to Astrologers Online | Bodhi App" />
        <meta property="og:description" content="Chat or call 700+ verified astrologers on Bodhi for Tarot, Kundli, Numerology, Vastu & love and career guidance. First consultation from Rs 9." />
        <meta property="og:image" content="https://www.bodhi.app/assets/img/bodhi/logo.png" />
        <meta property="og:site_name" content="Bodhi" />
        <meta property="og:locale" content="en_IN" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Talk to Astrologers Online | Bodhi App" />
        <meta name="twitter:description" content="Chat or call 700+ verified astrologers on Bodhi for Tarot, Kundli, Numerology & more. First consult from Rs 9." />
        <meta name="twitter:image" content="https://www.bodhi.app/assets/img/bodhi/logo.png" />

        <meta name="facebook-domain-verification" content="suustljldtul245zjqwcplvwqmek4i" />
        <meta name="theme-color" content="#000000" />

        <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script>
    </Helmet>);
}

export default Head;
